import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/actions'
import { getSelectedProductLifeProtectPlus } from 'quick-quote/product-life-protect-plus/selectors'

import BIMESSAGES from 'core/data-model/constants/bi-messages'

export const KoomverCompensateWLF99HProductSelection = ({
  getSelectedProductLifeProtectPlus,
  selectProductLifeProtectPlus,
}) => {
  const productKoomverCompensate = [
    {
      text: BIMESSAGES.PLAN_1,
      value: 'KOOMVER-COMPENSATE-1-WLF99H',
    },
    {
      text: BIMESSAGES.PLAN_2,
      value: 'KOOMVER-COMPENSATE-2-WLF99H',
    },
    {
      text: BIMESSAGES.PLAN_3,
      value: 'KOOMVER-COMPENSATE-3-WLF99H',
    },
    {
      text: BIMESSAGES.PLAN_4,
      value: 'KOOMVER-COMPENSATE-4-WLF99H',
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">{BIMESSAGES.QQ_SELECT_PLAN}</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductLifeProtectPlus}
        value={getSelectedProductLifeProtectPlus}
        options={productKoomverCompensate}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedProductLifeProtectPlus: getSelectedProductLifeProtectPlus(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductLifeProtectPlus: bindActionCreators(selectProductLifeProtectPlus, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(KoomverCompensateWLF99HProductSelection)
